<template>
	<v-dialog v-model="dialogValue" max-width="900px" persistent>
		<DialogPersonalizado :titulo="titulo()" icone="mdi-account-outline" @dialogClose="dialogClose">
			<v-row align="center" v-if="loading" justify="center" class="pa-4 pb-8">
				<v-progress-linear color="primary" indeterminate />
			</v-row>
			Nome
			<v-text-field
				v-model="usuario.nome"
				label="Nome"
				solo
				type="text"
				hide-details=""
				required
				:disabled="loading"
				class="mb-3"
			/>
			Cidade
			<v-select
				label="Cidade"
				solo
				color="red"
				item-color="red"
				v-model="usuario.cidade"
				:items="cidades"
				item-text="nome"
				item-value="nome"
				hide-details=""
				:disabled="loading"
				class="mb-3"
			></v-select>
			E-mail
			<v-text-field
				v-model="usuario.email"
				label="E-mail"
				solo
				type="email"
				required
				:disabled="loading"
				hide-details=""
				class="mb-3"
			/>
			<v-row v-if="id">
				<v-col cols="12" sm="6" md="3" v-if="userAdmin" class="pt-0 pb-0">
					<v-checkbox
						:ripple="false"
						v-model="usuario.ativo"
						label="Ativo?"
						color="#CC2128"
						:disabled="loading"
						hide-details
					></v-checkbox>
				</v-col>
				<v-col cols="12" sm="6" md="3" v-if="userMaster" class="pt-0 pb-0">
					<v-checkbox
						:ripple="false"
						label="Administrador?"
						v-model="usuario.admin"
						color="#CC2128"
						:disabled="loading"
						hide-details
					></v-checkbox>
				</v-col>
				<v-col cols="6" v-if="userMaster">
					<v-btn text color="red" @click="alterarSenha()" class="pa-0"> Alterar senha </v-btn>
				</v-col>
			</v-row>
			<v-row v-if="!id" class="mt-2 mb-2">
				<v-col cols="6" class="pt-0 pb-0">
					Senha
					<v-text-field
						solo
						placeholder="senha"
						v-model="usuario.senha"
						@click:append="show = !show"
						:type="show ? 'text' : 'password'"
						class="mb-3"
						hide-details
					>
						<template v-slot:append>
							<v-icon color="red" @click="show = !show">
								{{ show ? 'mdi-eye' : 'mdi-eye-off' }}
							</v-icon>
						</template>
					</v-text-field>
				</v-col>
				<v-col cols="6" class="pt-0 pb-0">
					Confirmar senha
					<v-text-field
						solo
						placeholder="senha"
						v-model.lazy="usuario.confirmarSenha"
						@click:append="show2 = !show2"
						:type="show2 ? 'text' : 'password'"
						class="mb-3"
						hide-details
					>
						<template v-slot:append>
							<v-icon color="red" @click="show2 = !show2">
								{{ show2 ? 'mdi-eye' : 'mdi-eye-off' }}
							</v-icon>
						</template>
					</v-text-field>
				</v-col>
			</v-row>
			<v-btn v-if="id && userMaster" class="red--text mt-4" @click="dialogExcluirOpen()" large width="100%">
				<v-icon>mdi-delete-outline</v-icon> Excluir
			</v-btn>
			<v-btn class="white--text mt-4" @click="salvar()" color="#CC2128" large elevation="9" width="100%">
				Salvar
			</v-btn>
		</DialogPersonalizado>
		<AlterarSenha :abrirDialog="abrir" @dialogClose="closeAlterarSenha" :id="this.id" tipo="usuario" />
		<DialogExcluir
			:abrirDialog="excluir"
			:id="this.id"
			@fecharDialog="dialogExcluirClose"
			@fecharTodosDialogs="dialogClose"
		/>
	</v-dialog>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import DialogPersonalizado from '../shared/dialogPersonalizado.vue'
import AlterarSenha from '../shared/RedefinirSenha.vue'
import DialogExcluir from './DialogExcluirUsuario.vue'

export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	data: function () {
		return {
			loading: false,
			show: false,
			show2: false,
			usuario: {},
			cidades: [
				{ uf: 'GO', nome: 'Jataí' },
				{ uf: 'GO', nome: 'Rio Verde' },
				{ uf: 'TO', nome: 'Palmas' },
			],
			abrir: false,
			excluir: false,
		}
	},
	components: {
		DialogPersonalizado,
		AlterarSenha,
		DialogExcluir,
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		dialogValue: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.dialogClose()
				//this.loadUsuarios()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),
		async salvar() {
			if (this.id) {
				this.editar()
			} else {
				this.criar()
			}
		},
		async criar() {
			if (!(this.usuario.senha == this.usuario.confirmarSenha))
				this.$store.dispatch('showError', 'As senhas não estão iguais')
			else {
				try {
					this.loading = true
					const response = await this.axios.post('/usuarios', {
						nome: this.usuario.nome,
						cidade: this.usuario.cidade,
						email: this.usuario.email,
						senha: this.usuario.senha,
					})

					if (response.status == 204) {
						this.$store.dispatch('showSuccess', 'Usuário cadastrado com sucesso')
						this.loadUsuarios()
						this.dialogClose()
					}
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.loading = false
				}
			}
		},
		async editar() {
			try {
				this.loading = true
				const response = await this.axios.put(`/usuarios/${this.usuario.id}`, this.usuario)

				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Usuário alterado com sucesso')
					this.loadUsuarios()
					this.dialogClose()
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async loadUsuario() {
			if (this.id) {
				try {
					this.loading = true
					const response = await this.axios.get(`/usuarios/${this.id}`)
					this.usuario = response.data.usuario
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.loading = false
				}
			}
		},
		titulo() {
			if (this.id) return 'Editar Usuário'
			else return 'Cadastrar Usuário'
		},
		loadUsuarios() {
			this.$emit('loadUsuarios')
		},
		dialogClose() {
			this.usuario = {}
			this.$emit('dialogClose')
			this.loadUsuarios()
		},
		alterarSenha() {
			this.abrir = true
		},
		closeAlterarSenha() {
			this.abrir = false
		},
		dialogExcluirOpen() {
			this.excluir = true
		},
		dialogExcluirClose() {
			this.excluir = false
		},
	},
	watch: {
		dialogValue() {
			if (this.dialogValue) {
				this.usuario = {}
				this.loadUsuario()
			}
		},
	},
}
</script>
